import type { Translations } from "./types";

export const ml: Translations = {
  nav: {
    home: "ഹോം",
    features: "ഫീച്ചറുകൾ",
    roadmap: "റോഡ്മാപ്പ്",
    faq: "FAQ",
    blog: "ബ്ലോഗ്",
    pricing: "നിരക്കുകൾ",
    contact: "ബന്ധപ്പെടുക",
    joinWaitlist: "കാത്തിരിപ്പ് പട്ടികയിൽ ചേരൂ",
    signIn: "സൈൻ ഇൻ",
  },
  footer: {
    tagline:
      "എതേറഎഡ്ജ്-ന്റെ സംരംഭം. അഡ്മിൻ ജോലികളിൽ സമയം കളയാതെ, പഠിപ്പിക്കലിൽ മാത്രം ശ്രദ്ധിക്കാൻ ആഗ്രഹിക്കുന്ന ട്യൂട്ടർമാർക്കായി.",
    pages: "പേജുകൾ",
    company: "കമ്പനി",
    contact: "കോൺടാക്ട്",
    social: "സോഷ്യൽ",
    legal: "നിയമപരം",
    copyright: "എതേറഎഡ്ജ് ലിമിറ്റഡ്. എല്ലാ അവകാശങ്ങളും സംരക്ഷിതം.",
    builtFor: "പുതിയ കാലത്തെ ട്യൂഷൻ സെന്ററുകൾക്കായി നിർമ്മിച്ചത്",
    home: "ഹോം",
    blog: "ബ്ലോഗ്",
    terms: "നിബന്ധനകൾ",
    privacy: "സ്വകാര്യത",
    aboutEtheraEdge: "എതേറഎഡ്ജ്-നെ കുറിച്ച്",
  },
  homepage: {
    hero: {
      tagline: "Now Live",
      headline: "ഫീസ് ചോദിച്ച് മടുത്തോ? ഇനി പഠിപ്പിക്കലിൽ മാത്രം ശ്രദ്ധിക്കൂ.",
      subheadline:
        "ഇൻവോയ്സുകൾ അയക്കാനും, വാട്സാപ്പിലൂടെ ഓർമ്മപ്പെടുത്താനും, പേയ്മെന്റുകൾ ട്രാക്ക് ചെയ്യാനും ഇനി ഓട്ടോമേറ്റഡ് സംവിധാനം — ഒന്നും ചെയ്യാതെ തന്നെ.",
      cta: "സൗജന്യമായി ആരംഭിക്കൂ — അൺലിമിറ്റഡ് വിദ്യാർത്ഥികൾ",
      secondaryCta: "Already know you need more? See pricing →",
      trustBadges: [
        "ഓട്ടോ & മാന്വൽ ഇൻവോയ്സിംഗ്",
        "പേയ്മെന്റ് ലിങ്കുള്ള വാട്സാപ്പ് ഓർമ്മപ്പെടുത്തലുകൾ",
        "സ്വയമേവ പണമടയ്ക്കൽ ട്രാക്കിംഗ്",
        "എല്ലാം ഒരൊറ്റ ബില്ലിൽ",
      ],
    },
    problem: {
      title: "ഈ അനുഭവങ്ങൾ നിങ്ങൾക്കുണ്ടാകാറുണ്ടോ?",
      subtitle: "ട്യൂട്ടർമാർ സ്ഥിരമായി പറയുന്ന പരാതികൾ ഇവയാണ്:",
      painPoints: [
        {
          title: "ഫീസിനായി സ്ഥിരമുള്ള വിളി",
          description:
            "ഫോൺ കോളുകൾ, വാട്സാപ്പ് മെസേജുകൾ, നാണക്കേടുണ്ടാക്കുന്ന ഓർമ്മപ്പെടുത്തലുകൾ. നിങ്ങൾ അധ്യാപകനാണ്, പണം പിരിക്കാനിറങ്ങിയ ആളല്ല.",
        },
        {
          title: "ഒരേ മെസേജുകൾ വീണ്ടും വീണ്ടും",
          description:
            "എല്ലാ ആഴ്ചയും രക്ഷിതാക്കൾക്ക് ഒരേ വാട്സാപ്പ് മെസേജുകൾ, എക്സലിൽ (Excel) കണക്കെഴുത്ത്. നിങ്ങൾ ഒരു സെക്രട്ടറിയെപ്പോലെ പണിയെടുക്കേണ്ട ആളല്ല.",
        },
        {
          title: "അഡ്മിൻ ജോലി കാരണം നഷ്ടപ്പെടുന്ന സമയം",
          description:
            "കൂടുതൽ നന്നായി ക്ലാസ്സെടുക്കാനോ, നോട്ടുകൾ തയ്യാറാക്കാനോ ഉപയോഗിക്കേണ്ട സമയം നിങ്ങൾ കണക്ക് കൂട്ടാൻ ചിലവാക്കുന്നു.",
        },
      ],
    },
    solution: {
      title: "എതേറഗുരു കൂടെയുണ്ടെങ്കിൽ, ഈ തലവേദനകൾ ഇല്ലാതാകും.",
      features: [
        {
          title: "സ്മാർട്ട് ഇൻവോയ്സിംഗ്",
          description:
            "എല്ലാ മാസവും നിശ്ചയിച്ച തീയതിയിൽ ഇൻവോയ്സുകൾ തനിയെ സൃഷ്ടിക്കപ്പെടും. ബാക്കിയുള്ള തുകയും ക്രെഡിറ്റുകളും അടുത്ത മാസത്തെ ബില്ലിൽ ഓട്ടോമാറ്റിക്കായി ചേർക്കപ്പെടും.",
        },
        {
          title: "കൃത്യമായ വാട്സാപ്പ് ഓർമ്മപ്പെടുത്തലുകൾ",
          description:
            "ബില്ല് അയക്കുമ്പോഴും, അവസാന തീയതിക്ക് മുൻപും, വൈകുമ്പോഴും രക്ഷിതാക്കൾക്ക് ഓട്ടോമാറ്റിക് മെസേജുകൾ പോകും. ആവശ്യമെങ്കിൽ നിങ്ങൾക്ക് നേരിട്ടും അയക്കാം.",
        },
        {
          title: "പേയ്മെന്റ് ലിങ്കുകൾ & ട്രാക്കിംഗ്",
          description:
            "ഓർമ്മപ്പെടുത്തലുകൾക്കൊപ്പം പേയ്മെന്റ് ലിങ്കുകൾ അയക്കാം. രക്ഷിതാക്കൾ പണമടച്ചാൽ സിസ്റ്റം തനിയെ 'പണമടച്ചു' എന്ന് രേഖപ്പെടുത്തും. പാർഷ്യൽ പേയ്മെന്റും ഇതിൽ സാധ്യമാണ്.",
        },
        {
          title: "ഏകീകൃത ബില്ലിംഗ്",
          description:
            "ഓരോ വിദ്യാർത്ഥിക്കും കൃത്യമായ ഒരു ബില്ല്. ബാലൻസ് തുകകളും ക്രെഡിറ്റുകളും എല്ലാം കൃത്യമായി കണക്കാക്കപ്പെടുന്നു. സ്പ്രെഡ്ഷീറ്റിലെ കണക്കുകൾ ഇനി വേണ്ട.",
        },
      ],
    },
    roadmap: {
      title: "ഭാവി മുന്നിൽ കണ്ടുള്ള മാറ്റങ്ങൾ",
      subtitle: "ഒന്നും രണ്ടും ഘട്ടങ്ങൾ ഇപ്പോൾ ലൈവ്. കൂടുതൽ ഫീച്ചറുകൾ ഉടൻ വരുന്നു.",
      phases: [
        {
          phase: "ഒന്നാം ഘട്ടം",
          title: "ഫീ കളക്ഷൻ",
          description: "ഓട്ടോമേറ്റഡ് ഓർമ്മപ്പെടുത്തലുകൾ, പേയ്മെന്റ് ട്രാക്കിംഗ്",
          status: "ഇപ്പോൾ ലൈവ്",
          icon: "money",
          glyph: "invoice",
        },
        {
          phase: "രണ്ടാം ഘട്ടം",
          title: "ഫീ അനാലിറ്റിക്സും മൾട്ടി-ബ്രാഞ്ചും",
          description: "കോഴ്സുകൾ, ബാച്ചുകൾ, എല്ലാ ബ്രാഞ്ചുകളിലുമുള്ള കളക്ഷൻ നിരക്കുകൾ, വരുമാന ട്രെൻഡുകൾ, ഓവർഡ്യൂ പാറ്റേണുകൾ.",
          status: "ഇപ്പോൾ ലൈവ്",
          icon: "file",
          glyph: "analytics",
        },
        {
          phase: "ഉടൻ വരുന്നു",
          title: "File Sharing മൊഡ്യൂൾ",
          description:
            "നോട്ടുകൾ, അസൈൻമെന്റുകൾ, റെക്കോർഡിംഗുകൾ വാട്സാപ്പിലൂടെ വിദ്യാർത്ഥികൾക്കും രക്ഷിതാക്കൾക്കും പങ്കിടാൻ",
          status: "വികസനത്തിലാണ്",
          icon: "file",
          glyph: "files",
        },
        {
          phase: "ഉടൻ വരുന്നു",
          title: "ഷെഡ്യൂളിംഗും അറ്റൻഡൻസും",
          description: "ക്ലാസ് ഷെഡ്യൂളുകൾ, ഹാജർ ട്രാക്കിംഗ്, ഓട്ടോമേറ്റഡ് റിപ്പോർട്ടുകൾ",
          status: "ഉടൻ വരുന്നു",
          icon: "users",
          glyph: "calendar",
        },
        {
          phase: "ഉടൻ വരുന്നു",
          title: "പാരന്റ് അപ്ഡേറ്റുകൾ",
          description: "കുട്ടികളുടെ പ്രോഗ്രസ് റിപ്പോർട്ടുകൾ രക്ഷിതാക്കളെ അറിയിക്കാൻ",
          status: "പ്ലാൻ ചെയ്തിരിക്കുന്നു",
          icon: "bell",
          glyph: "parent",
        },
      ],
    },
    valueGrowth: {
      title: "നിങ്ങൾക്കായി, നിങ്ങളോടൊപ്പം നിർമിക്കുന്നത്",
      subtitle: "നിങ്ങളുടെ അഭിപ്രായങ്ങളാണ് ഞങ്ങളുടെ വളർച്ച. യഥാർത്ഥ പ്രശ്നങ്ങൾക്കുള്ള പരിഹാരങ്ങളാണ് ഞങ്ങൾ കൊണ്ടുവരുന്നത്.",
      cards: [
        {
          title: "ഫ്രീ പ്ലാൻ ശരിക്കും ഉപയോഗിക്കാം",
          description:
            "മറ്റ് ആപ്പുകൾ ഫ്രീ ടയർ ദുർബലമാക്കും. ഞങ്ങൾ അങ്ങനെയല്ല. 150 മെസേജുകൾ, അൺലിമിറ്റഡ് വിദ്യാർത്ഥികളും ട്യൂട്ടർമാരും, എല്ലാ ഫീച്ചറുകളും.",
          icon: "heart",
        },
        {
          title: "നിങ്ങൾ തയ്യാറാകുമ്പോൾ അപ്‌ഗ്രേഡ് ചെയ്യൂ",
          description:
            "വ്യക്തമായ പരിധികൾ, വ്യക്തമായ അപ്‌ഗ്രേഡ് പാത. അപ്രതീക്ഷിത ബില്ലുകളില്ല. നിങ്ങളുടെ ടയർ മതിയാകാതെ വരുമ്പോൾ അടുത്തതിലേക്ക് മാറൂ.",
          icon: "growth",
        },
        {
          title: "എല്ലാ പ്ലാനിലും എല്ലാ ഫീച്ചറുകളും",
          description:
            "ഞങ്ങൾ ഫീച്ചറുകൾ നിയന്ത്രിക്കില്ല. എല്ലാ പ്ലാനിലും എല്ലാം ലഭിക്കും. പരിധികളും സപ്പോർട്ട് ലെവലുകളും മാത്രം വ്യത്യാസപ്പെടും.",
          icon: "gift",
        },
      ],
      bottomNote: "അടുത്ത തലമുറ ട്യൂഷൻ മാനേജ്മെന്റ് സിസ്റ്റം ഞങ്ങൾ നിർമ്മിക്കുകയാണ് — നിങ്ങളുടെ നിർദ്ദേശങ്ങൾക്കൊപ്പം.",
    },
    pricing: {
      title: "ലളിതമായ വില. വ്യക്തമായ പരിധികൾ. വളരുമ്പോൾ അപ്‌ഗ്രേഡ് ചെയ്യൂ.",
      subtitle:
        "എല്ലാ പ്ലാനിലും അൺലിമിറ്റഡ് വിദ്യാർത്ഥികൾ, അൺലിമിറ്റഡ് ട്യൂട്ടർമാർ, എല്ലാ ഫീച്ചറുകളും. നിങ്ങളുടെ മെസേജ് വോള്യം തിരഞ്ഞെടുക്കൂ.",
      launchBadge: "🚀 ഇപ്പോൾ ലൈവ് — സൗജന്യമായി തുടങ്ങൂ",
      annualBilling: {
        monthlyLabel: "പ്രതിമാസം",
        annualLabel: "വാർഷികം",
        saveBadge: "16% ലാഭിക്കൂ",
      },
      labels: {
        messages: "മെസേജുകൾ",
        storage: "സ്റ്റോറേജ്",
        branches: "ബ്രാഞ്ചുകൾ",
        included: "ഉൾപ്പെടുന്നവ",
      },
      tiers: [
        {
          id: "lite",
          name: "Lite",
          price: "₹1,499",
          period: "/മാസം",
          annualPrice: "₹14,990/വർഷം",
          annualSavings: "₹2,998 ലാഭിക്കൂ (16%)",
          description: "ഓട്ടോമേഷൻ ആഗ്രഹിക്കുന്ന വളരുന്ന ട്യൂട്ടർമാർക്ക്.",
          valueFraming:
            "50-100 വിദ്യാർത്ഥികളുള്ള ട്യൂട്ടർമാർക്ക്. ബ്രാഞ്ചുകളോ മൊഡ്യൂളുകളോ വേണ്ടി Scale-ലേക്ക് അപ്‌ഗ്രേഡ് ചെയ്യൂ.",
          whatsappLimit: "700",
          storageLimit: "5 GB",
          branchesIncluded: "1",
          canBuyExtras: false,
          supportLevel: "വാട്സാപ്പ് (48 മണിക്കൂർ)",
          features: [
            "അൺലിമിറ്റഡ് വിദ്യാർത്ഥികൾ",
            "അൺലിമിറ്റഡ് ട്യൂട്ടർമാർ",
            "700 വാട്സാപ്പ് മെസേജുകൾ/മാസം",
            "5 GB ഫയൽ സ്റ്റോറേജ്",
            "1 ബ്രാഞ്ച്",
            "എല്ലാ കോർ ഫീച്ചറുകളും ഉൾപ്പെടുന്നു",
            "വാട്സാപ്പ് സപ്പോർട്ട് (48 മണിക്കൂർ)",
          ],
          cta: "ഫ്രീയിൽ തുടങ്ങി, പിന്നീട് അപ്‌ഗ്രേഡ് ചെയ്യൂ",
          highlighted: false,
          badge: "മികച്ച മൂല്യം",
          belowCta: "ബ്രാഞ്ചുകളോ മൊഡ്യൂളുകളോ വേണോ? Scale-ലേക്ക് അപ്‌ഗ്രേഡ് ചെയ്യൂ.",
        },
        {
          id: "scale",
          name: "Scale",
          price: "₹2,499",
          period: "/മാസം",
          annualPrice: "₹24,990/വർഷം",
          annualSavings: "₹4,998 ലാഭിക്കൂ (16%)",
          description: "കോച്ചിംഗ് സെന്ററുകൾക്ക്. ആവശ്യമുള്ളപ്പോൾ ഫ്ലെക്സിബിലിറ്റി.",
          valueFraming:
            "100-500 വിദ്യാർത്ഥികളുള്ള സ്ഥാപനങ്ങൾക്ക്. മൾട്ടി-ബ്രാഞ്ച് ആഡ്-ഓൺ ലഭ്യം, File Sharing ഉടൻ വരുന്നു.",
          whatsappLimit: "1,500",
          storageLimit: "25 GB",
          branchesIncluded: "1",
          canBuyExtras: true,
          extraMessagePrice: "₹1.25/msg",
          supportLevel: "പ്രയോറിറ്റി (24 മണിക്കൂർ)",
          features: [
            "അൺലിമിറ്റഡ് വിദ്യാർത്ഥികൾ",
            "അൺലിമിറ്റഡ് ട്യൂട്ടർമാർ",
            "1,500 വാട്സാപ്പ് മെസേജുകൾ/മാസം",
            "25 GB ഫയൽ സ്റ്റോറേജ്",
            "1 ബ്രാഞ്ച് ഉൾപ്പെടുന്നു",
            "എല്ലാ കോർ ഫീച്ചറുകളും ഉൾപ്പെടുന്നു",
            "✅ ₹1.25/msg-ൽ എക്സ്ട്രാ മെസേജുകൾ വാങ്ങാം",
            "✅ മൾട്ടി-ബ്രാഞ്ച് ആഡ്-ഓൺ ₹499/ബ്രാഞ്ച്/മാസം",
            "⏳ File Sharing മൊഡ്യൂൾ (ഉടൻ വരുന്നു)",
            "പ്രയോറിറ്റി സപ്പോർട്ട് (24 മണിക്കൂർ)",
          ],
          cta: "ഫ്രീയിൽ തുടങ്ങി, പിന്നീട് അപ്‌ഗ്രേഡ് ചെയ്യൂ",
          highlighted: true,
          badge: "ഏറ്റവും ജനപ്രിയം",
          belowCta: "30 ദിവസത്തെ സൗജന്യ ട്രയൽ — കാർഡ് വേണ്ട",
        },
        {
          id: "custom",
          name: "Custom",
          price: "ഞങ്ങളോട് സംസാരിക്കൂ",
          period: "",
          description: "വലിയ സ്ഥാപനങ്ങൾക്ക്. നിങ്ങളുടെ നിയമങ്ങൾ, നിങ്ങളുടെ പരിധികൾ.",
          valueFraming: "കസ്റ്റം പരിധികൾ, ഡെഡിക്കേറ്റഡ് സപ്പോർട്ട്, SLA-കൾ — നിങ്ങളുടെ ആവശ്യങ്ങൾക്കനുസരിച്ച്.",
          whatsappLimit: "കസ്റ്റം",
          storageLimit: "കസ്റ്റം",
          branchesIncluded: "അൺലിമിറ്റഡ്",
          canBuyExtras: true,
          extraMessagePrice: "കസ്റ്റം നിരക്കുകൾ",
          supportLevel: "ഡെഡിക്കേറ്റഡ് അക്കൗണ്ട് മാനേജർ",
          features: [
            "അൺലിമിറ്റഡ് വിദ്യാർത്ഥികൾ",
            "അൺലിമിറ്റഡ് ട്യൂട്ടർമാർ",
            "കസ്റ്റം വാട്സാപ്പ് ക്വോട്ട",
            "എല്ലാ ഫീച്ചറുകളും ഉൾപ്പെടുന്നു",
            "കസ്റ്റം എക്സ്ട്രാ മെസേജ് നിരക്കുകൾ",
            "ഡെഡിക്കേറ്റഡ് അക്കൗണ്ട് മാനേജർ",
            "കസ്റ്റം ഇന്റഗ്രേഷനുകൾ",
            "SLA ലഭ്യമാണ്",
            "മൾട്ടി-ബ്രാഞ്ച് സപ്പോർട്ട്",
          ],
          cta: "ഞങ്ങളെ ബന്ധപ്പെടൂ",
          ctaLink: "mailto:hello@etheraguru.com",
          highlighted: false,
          isCustom: true,
          belowCta: "1,000+ മെസേജുകൾ/മാസം ഉള്ള കോച്ചിംഗ് സെന്ററുകൾക്ക്",
        },
      ],
      payAsYouGo: {
        title: "700-ൽ കൂടുതൽ മെസേജുകൾ വേണോ?",
        note: "Scale ഉപയോക്താക്കൾക്ക് ₹1.25-ന് എക്സ്ട്രാ മെസേജുകൾ വാങ്ങാം. മറ്റ് ടയറുകൾ പരിധി എത്തുമ്പോൾ അപ്‌ഗ്രേഡ് ചെയ്യണം.",
        steps: [],
        spendCap: {
          icon: "💡",
          title: "വ്യക്തമായ അപ്‌ഗ്രേഡ് പാത",
          description:
            "Free → Starter → Growth → Scale. പരിധി എത്തിയോ? കൂടുതൽ കപ്പാസിറ്റിക്ക് അടുത്ത ടയറിലേക്ക് മാറൂ.",
        },
      },
      roiPositioning: {
        title: "ഇതെന്തുകൊണ്ട് മികച്ചതാകുന്നു?",
        pillars: [
          {
            title: "പണം തിരിച്ചു കിട്ടുന്നു",
            description: "കൃത്യമായ ഓർമ്മപ്പെടുത്തലുകൾ ഉള്ളതുകൊണ്ട് പേയ്മെന്റ് മുടങ്ങില്ല, വേഗത്തിൽ ഫീസ് ലഭിക്കും.",
          },
          {
            title: "സമയം ലാഭിക്കുന്നു",
            description: "മാന്വൽ ഫോളോ-അപ്പുകൾ ഇനി വേണ്ട. ആ സമയം പഠിപ്പിക്കാനോ വിശ്രമിക്കാനോ ഉപയോഗിക്കാം.",
          },
          {
            title: "പ്രവചനീയമായ ചെലവുകൾ",
            description:
              "നിശ്ചിത പ്രതിമാസ വില. അപ്രതീക്ഷിത ബില്ലുകളില്ല. നിങ്ങളുടെ ടയർ മതിയാകാതെ വരുമ്പോൾ മാത്രം അപ്‌ഗ്രേഡ് ചെയ്യൂ.",
          },
        ],
        featureGrowth: "എല്ലാ പ്ലാനിലും എല്ലാ ഫീച്ചറുകളും ഉൾപ്പെടുന്നു. പരിധികളും സപ്പോർട്ടും മാത്രം വ്യത്യാസപ്പെടും.",
      },
    },
    social: {
      title: "ബന്ധപ്പെടാം",
      subtitle: "അപ്‌ഡേറ്റുകൾക്കും ടിപ്പുകൾക്കുമായി ഞങ്ങളെ ഫോളോ ചെയ്യുക",
    },
    finalCta: {
      headline: "ഫീസ് പിരിവിന്റെ തലവേദന ഒഴിവാക്കാൻ തയ്യാറാണോ?",
      subheadline:
        "അൺലിമിറ്റഡ് വിദ്യാർത്ഥികളോടെ സൗജന്യമായി തുടങ്ങൂ. ക്രെഡിറ്റ് കാർഡ് വേണ്ട. കമ്മിറ്റ്മെന്റ് വേണ്ട. മികച്ച ഫീസ് കളക്ഷൻ മാത്രം.",
      cta: "സൗജന്യമായി തുടങ്ങൂ",
      alternative: "ഏത് പ്ലാൻ എന്ന് ഉറപ്പില്ലേ? ഫ്രീയിൽ തുടങ്ങൂ — കൂടുതൽ വേണമെന്ന് തോന്നുമ്പോൾ ഞങ്ങൾ സഹായിക്കാം.",
      privacyNote: "ചെറിയ ട്യൂട്ടർമാർക്ക് എന്നേക്കും സൗജന്യം. നിങ്ങളുടെ ബിസിനസ് ആവശ്യപ്പെടുമ്പോൾ മാത്രം അപ്‌ഗ്രേഡ് ചെയ്യൂ.",
      whatsappAlternative: "ചോദ്യങ്ങളുണ്ടോ? വാട്സാപ്പിൽ ചാറ്റ് ചെയ്യൂ →",
    },
    faq: {
      title: "പതിവ് ചോദ്യങ്ങൾ",
      items: [
        {
          question: "തുടങ്ങാൻ ക്രെഡിറ്റ് കാർഡ് വേണോ?",
          answer: "വേണ്ട. ഫ്രീ ടയറിന് പേയ്മെന്റ് വിവരങ്ങൾ വേണ്ട. സൈൻ അപ്പ് ചെയ്തു തുടങ്ങൂ.",
        },
        {
          question: "രക്ഷിതാക്കൾ ഏത് പേയ്മെന്റ് രീതികൾ ഉപയോഗിക്കുന്നു?",
          answer:
            "UPI, ക്രെഡിറ്റ്/ഡെബിറ്റ് കാർഡുകൾ, നെറ്റ് ബാങ്കിംഗ്, ഡിജിറ്റൽ വാലറ്റുകൾ വഴി പേയ്മെന്റ് ചെയ്യാം. പണം നേരിട്ട് നിങ്ങളുടെ ബാങ്ക് അക്കൗണ്ടിലേക്ക് പോകും.",
        },
        {
          question: "എതേറഗുരു എനിക്ക് ഉപയോഗപ്രദമല്ലെങ്കിൽ എന്ത് ചെയ്യും?",
          answer:
            "ഫ്രീയിൽ തുടങ്ങി നേരിട്ട് പരീക്ഷിക്കൂ. പെയ്ഡ് പ്ലാനിലാണെങ്കിൽ മൂല്യം കാണുന്നില്ലെങ്കിൽ എപ്പോൾ വേണമെങ്കിലും ക്യാൻസൽ ചെയ്യാം — ചോദ്യങ്ങളില്ല.",
        },
        {
          question: "എതേറഗുരു പേയ്മെന്റ് കളക്ഷനു ചാർജ് ചെയ്യുമോ?",
          answer:
            "ഇല്ല. പേയ്മെന്റ് ലിങ്കുകൾ എല്ലാ പ്ലാനുകളിലും ഉൾപ്പെടുന്നു. ഞങ്ങൾ നിങ്ങളുടെ Razorpay അക്കൗണ്ട് സെറ്റപ്പ് ചെയ്യാൻ സഹായിക്കും, പേയ്മെന്റുകൾ നേരിട്ട് നിങ്ങളുടെ ബാങ്കിലേക്ക് പോകും. Razorpay അവരുടെ സ്റ്റാൻഡേർഡ് ഫീസ് (~2%) ചാർജ് ചെയ്യുന്നു — ഞങ്ങൾ ഒരു മാർക്കപ്പും ചേർക്കുന്നില്ല.",
        },
      ],
    },
  },
  pricing: {
    hero: {
      title: "സുതാര്യമായ നിരക്കുകൾ - ഹിഡൻ ചാർജുകളില്ല",
      subtitle: "എല്ലാ വാട്സാപ്പ് ചെലവുകളും ഇതിൽ ഉൾപ്പെടും. നിങ്ങൾ കാണുന്ന തുക മാത്രം നൽകിയാൽ മതി.",
    },

    roi: {
      title: "കാണൂ: നിങ്ങൾക്ക് എത്ര പണം നഷ്ടപ്പെടുന്നു",
      description: "ഫീസ് വൈകി ലഭിക്കുന്നത് വഴി നിങ്ങളുടെ വരുമാനത്തിൽ എത്ര കാലതാമസം വരുന്നുണ്ടെന്ന് കണക്കാക്കാം.",
      inputs: {
        students: "വിദ്യാർത്ഥികളുടെ എണ്ണം",
        avgFee: "ശരാശരി ഫീസ് (₹)",
        latePercent: "എത്ര ശതമാനം പേർ വൈകിയാണ് ഫീസ് അടയ്ക്കുന്നത്?",
        avgDaysLate: "ശരാശരി എത്ര ദിവസം വൈകുന്നു",
      },
      results: {
        monthlyRevenue: "പ്രതിമാസ വരുമാനം",
        delayedRevenue: "ഓരോ മാസവും വൈകി ലഭിക്കുന്ന തുക",
        cashFlowLost: "നഷ്ടപ്പെടുന്ന ക്യാഷ് ഫ്ലോ",
        potentialRecovery: "എതേറഗുരു ഉപയോഗിച്ചാൽ: ഇത്രയും വരെ റിക്കവർ ചെയ്യാം",
        roi: "നിങ്ങളുടെ ലാഭം (ROI)",
      },
      cta: "നഷ്ടം നികത്താൻ കാത്തിരിപ്പ് പട്ടികയിൽ ചേരൂ",
    },
    comparisonTable: {
      title: "എല്ലാ പ്ലാനുകളും താരതമ്യം ചെയ്യൂ",
      headers: {
        feature: "ഫീച്ചർ",
        lite: "Lite",
        scale: "Scale",
        custom: "Custom",
      },
      rows: [
        {
          feature: "വില",
          lite: "₹1,499/മാസം",
          scale: "₹2,499/മാസം",
          custom: "ഞങ്ങളോട് സംസാരിക്കൂ",
        },
        {
          feature: "വാട്സാപ്പ് മെസേജുകൾ",
          lite: "700",
          scale: "1,500",
          custom: "കസ്റ്റം",
        },
        {
          feature: "എക്സ്ട്രാ മെസേജുകൾ",
          lite: "❌",
          scale: "✅ ₹1.25/msg",
          custom: "കസ്റ്റം",
        },
        {
          feature: "ഫയൽ സ്റ്റോറേജ്",
          lite: "5 GB",
          scale: "25 GB",
          custom: "കസ്റ്റം",
        },
        {
          feature: "ബ്രാഞ്ചുകൾ ഉൾപ്പെടുന്നു",
          lite: "1",
          scale: "1",
          custom: "അൺലിമിറ്റഡ്",
        },
        {
          feature: "മൾട്ടി-ബ്രാഞ്ച് ആഡ്-ഓൺ",
          lite: "❌",
          scale: "✅ ₹499/ബ്രാഞ്ച്/മാസം",
          custom: "ഉൾപ്പെടുന്നു",
        },
        {
          feature: "File Sharing ആഡ്-ഓൺ",
          lite: "❌",
          scale: "ഉടൻ വരുന്നു",
          custom: "ഉടൻ വരുന്നു",
        },
        {
          feature: "വിദ്യാർത്ഥികൾ",
          lite: "അൺലിമിറ്റഡ്",
          scale: "അൺലിമിറ്റഡ്",
          custom: "അൺലിമിറ്റഡ്",
        },
        {
          feature: "ട്യൂട്ടർമാർ",
          lite: "അൺലിമിറ്റഡ്",
          scale: "അൺലിമിറ്റഡ്",
          custom: "അൺലിമിറ്റഡ്",
        },
        {
          feature: "ഫീ ഓർമ്മപ്പെടുത്തലുകൾ",
          lite: "✅",
          scale: "✅",
          custom: "✅",
        },
        {
          feature: "ഇൻവോയ്സ് ജനറേഷൻ",
          lite: "✅",
          scale: "✅",
          custom: "✅",
        },
        {
          feature: "പേയ്മെന്റ് ട്രാക്കിംഗ്",
          lite: "✅",
          scale: "✅",
          custom: "✅",
        },
        {
          feature: "ബാച്ച് മാനേജ്മെന്റ്",
          lite: "✅",
          scale: "✅",
          custom: "✅",
        },
        {
          feature: "ഫീ അനാലിറ്റിക്സ്",
          lite: "✅",
          scale: "✅",
          custom: "✅",
        },
        {
          feature: "SLA",
          lite: "❌",
          scale: "❌",
          custom: "✅",
        },
        {
          feature: "സപ്പോർട്ട്",
          lite: "വാട്സാപ്പ് (48 മണിക്കൂർ)",
          scale: "പ്രയോറിറ്റി (24 മണിക്കൂർ)",
          custom: "ഡെഡിക്കേറ്റഡ്",
        },
      ],
    },
    dedicatedFaq: {
      title: "പ്രൈസിംഗ് FAQ",
      items: [
        {
          question: "മെസേജ് പരിധി എത്തിയാൽ എന്ത് സംഭവിക്കും?",
          answer:
            "അടുത്ത മാസം വരെ മെസേജുകൾ പോസ് ആകും, അല്ലെങ്കിൽ ഉടൻ അപ്‌ഗ്രേഡ് ചെയ്യാം. Scale ഉപയോക്താക്കൾക്ക് പകരം ₹1.25/msg-ന് എക്സ്ട്രാ വാങ്ങാം.",
        },
        {
          question: "Free/Starter/Growth-ൽ എക്സ്ട്രാ മെസേജുകൾ വാങ്ങാൻ കഴിയാത്തത് എന്തുകൊണ്ട്?",
          answer:
            "ലാളിത്യം. ഓരോ ടയറിനും വ്യക്തമായ പരിധിയുണ്ട് — തുടർച്ചയായി കൂടുതൽ വേണമെങ്കിൽ, അപ്‌ഗ്രേഡ് ചെയ്യുന്നത് മികച്ച മൂല്യം നൽകും. Scale-ൽ മാത്രമാണ് എക്സ്ട്രാ ഒരു പ്രീമിയം ഫീച്ചറായി ഉൾപ്പെടുത്തിയിരിക്കുന്നത്.",
        },
        {
          question: "Growth ₹999 ആണെങ്കിൽ Scale-ന് ₹1,499 നൽകേണ്ടത് എന്തുകൊണ്ട്?",
          answer:
            "Scale ഫ്ലെക്സിബിലിറ്റി ആവശ്യമുള്ള ട്യൂട്ടർമാർക്കും സെന്ററുകൾക്കും വേണ്ടിയാണ്. 700 മെസേജുകൾ (500-ന് പകരം), പ്രയോറിറ്റി സപ്പോർട്ട്, ആവശ്യമുള്ളപ്പോൾ ₹1.25/msg-ന് എക്സ്ട്രാ വാങ്ങാനുള്ള കഴിവ് എന്നിവ ലഭിക്കും.",
        },
        {
          question: "എപ്പോൾ വേണമെങ്കിലും അപ്‌ഗ്രേഡ് അല്ലെങ്കിൽ ഡൗൺഗ്രേഡ് ചെയ്യാമോ?",
          answer:
            "അതെ! ഉടൻ അപ്‌ഗ്രേഡ് ചെയ്യാം — പുതിയ പരിധി ഉടൻ ബാധകമാകും. ബില്ലിംഗ് സൈക്കിൾ അവസാനിക്കുമ്പോൾ ഡൗൺഗ്രേഡ് ചെയ്യാം. ലോക്ക്-ഇൻ ഇല്ല.",
        },
        {
          question: "ഉപയോഗിക്കാത്ത മെസേജുകൾ അടുത്ത മാസത്തേക്ക് കൊണ്ടുപോകാമോ?",
          answer: "ഇല്ല, പരിധികൾ പ്രതിമാസം റീസെറ്റ് ആകും. പക്ഷേ എല്ലാം ഉപയോഗിക്കാത്തതിന് പെനാൽറ്റിയില്ല.",
        },
        {
          question: "എല്ലാ പ്ലാനിലും വിദ്യാർത്ഥികളും ട്യൂട്ടർമാരും അൺലിമിറ്റഡ് ആയിരിക്കുന്നത് എന്തുകൊണ്ട്?",
          answer:
            "അവർ ഞങ്ങൾക്ക് ചെലവ് വരുത്തുന്നില്ല, അപ്പോൾ എന്തിന് നിയന്ത്രിക്കണം? ചെലവ് വരുത്തുന്ന കാര്യങ്ങൾക്ക് മാത്രം ഞങ്ങൾ ചാർജ് ചെയ്യുന്നു: വാട്സാപ്പ് മെസേജുകൾ.",
        },
        {
          question: "വാർഷിക ബില്ലിംഗ് എന്താണ്?",
          answer:
            "വാർഷിക ബില്ലിംഗിൽ 16% ലാഭിക്കൂ (2 മാസം സൗജന്യം). Starter: ₹4,990/വർഷം, Growth: ₹9,990/വർഷം, Scale: ₹14,990/വർഷം.",
        },
        {
          question: "Custom പ്രൈസിംഗ് എപ്പോൾ പരിഗണിക്കണം?",
          answer:
            "പ്രതിമാസം 1,000+ മെസേജുകൾ, ഒന്നിലധികം ബ്രാഞ്ചുകൾ, കസ്റ്റം SLA-കൾ, അല്ലെങ്കിൽ ഇൻവോയ്സ് അടിസ്ഥാനമാക്കിയ ബില്ലിംഗ് വേണമെങ്കിൽ. hello@etheraguru.com-ൽ ബന്ധപ്പെടൂ.",
        },
      ],
    },
  },
  blog: {
    title: "ട്യൂഷൻ ബിസിനസ് ബ്ലോഗ്",
    subtitle: "ട്യൂഷൻ സെന്ററുകൾക്കും ട്യൂട്ടർമാർക്കും വേണ്ടിയുള്ള അപ്‌ഡേറ്റുകളും നിർദ്ദേശങ്ങളും",
    noPosts: "പോസ്റ്റുകൾ ലഭ്യമല്ല. ഉടൻ വീണ്ടും പരിശോധിക്കുക!",
    readMore: "കൂടുതൽ വായിക്കുക",
    previous: "മുമ്പത്തെ",
    next: "അടുത്തത്",
    showing: "കാണിക്കുന്നു",
    of: "/",
    posts: "പോസ്റ്റുകൾ",
    showAll: "എല്ലാ ഭാഷകളും കാണിക്കുക",
    showingOnly: "കാണിക്കുന്നു",
    postsIn: "പോസ്റ്റുകൾ",
    otherPosts: "മറ്റ് ഭാഷാ പോസ്റ്റുകൾ ലഭ്യമാണ്",
    backToBlog: "ബ്ലോഗിലേക്ക് മടങ്ങുക",
    backToAllPosts: "എല്ലാ പോസ്റ്റുകളിലേക്കും മടങ്ങുക",
  },
  pwa: {
    install: "ആപ്പ് ഇൻസ്റ്റാൾ ചെയ്യുക",
    iosTitle: "EtheraGuru ഇൻസ്റ്റാൾ ചെയ്യുക",
    iosDescription: "നിങ്ങളുടെ iOS ഉപകരണത്തിൽ ഈ ആപ്പ് ഇൻസ്റ്റാൾ ചെയ്യാൻ:",
    iosStep1: "Share ബട്ടൺ ടാപ്പ് ചെയ്യുക",
    iosStep2: "താഴേക്ക് സ്ക്രോൾ ചെയ്ത് 'Add to Home Screen' ടാപ്പ് ചെയ്യുക",
    iosStep3: "സ്ഥിരീകരിക്കാൻ 'Add' ടാപ്പ് ചെയ്യുക",
    bannerTitle: "EtheraGuru ഇൻസ്റ്റാൾ ചെയ്യുക",
    bannerDescription: "വേഗത്തിലുള്ള ആക്സസിനായി ഹോം സ്ക്രീനിൽ ചേർക്കുക",
  },
  contact: {
    title: "ഞങ്ങളെ ബന്ധപ്പെടുക",
    subtitle:
      "EtheraGuru-നെ കുറിച്ച് ചോദ്യങ്ങളുണ്ടോ? ഞങ്ങൾ സഹായിക്കാൻ ഇവിടെയുണ്ട്. വാട്സാപ്പിൽ ബന്ധപ്പെടൂ, ഞങ്ങൾ എത്രയും വേഗം മറുപടി നൽകാം.",
    eyebrow: "ഞങ്ങളോട് സംസാരിക്കൂ",
    responseTime: "സാധാരണയായി ഏതാനും മണിക്കൂറുകൾക്കുള്ളിൽ ഞങ്ങൾ മറുപടി നൽകും",
    statusOnline: "ഇപ്പോൾ ഓൺലൈൻ",
    statusAway: "ഇപ്പോൾ ലഭ്യമല്ല",
    realPersonTitle: "ബോട്ട് അല്ല, ഒരു യഥാർത്ഥ വ്യക്തി",
    realPersonBody: "നിങ്ങളുടെ സന്ദേശം നേരിട്ട് ഞങ്ങളുടെ ടീമിലെത്തും — ടിക്കറ്റ് ക്യൂ ഇല്ല, കറക്കം ഇല്ല.",
    quickRepliesTitle: "വേഗത്തിൽ മറുപടി",
    privacyTitle: "സ്വാഭാവികമായി സ്വകാര്യം",
    privacyBody: "നിങ്ങളെ സഹായിക്കാൻ മാത്രമേ ഞങ്ങൾ നിങ്ങളുടെ സന്ദേശം ഉപയോഗിക്കൂ. പങ്കിടില്ല, സ്പാം ചെയ്യില്ല.",
    quickStartTitle: "എവിടെ തുടങ്ങണമെന്ന് ഉറപ്പില്ലേ? ഒരു ചോദ്യം ടാപ്പ് ചെയ്യൂ:",
    quickPromptPricing: "എന്റെ സെന്ററിന് ഇതിന് എത്ര ചെലവാകും?",
    quickPromptDemo: "എനിക്ക് ഒരു ഡെമോ ലഭിക്കുമോ?",
    quickPromptSwitch: "സ്പ്രെഡ്ഷീറ്റുകളിൽ നിന്ന് എങ്ങനെ മാറാം?",
    typingLabel: "ടൈപ്പ് ചെയ്യുന്നു…",
    emailFallbackTitle: "ഇമെയിൽ ആണോ തിരഞ്ഞെടുക്കുന്നത്?",
    emailFallbackDescription: "contact@etheraedge.com എന്ന വിലാസത്തിലും ഞങ്ങളെ ബന്ധപ്പെടാം",
    whatsappCardHeader: "വാട്സാപ്പിൽ ഞങ്ങളോട് ചാറ്റ് ചെയ്യൂ",
    whatsappCardBody:
      "ചോദ്യങ്ങളുണ്ടോ? ഞങ്ങൾ സഹായിക്കാൻ ഇവിടെയുണ്ട്. ഒരു വാട്സാപ്പ് സംഭാഷണം ആരംഭിക്കൂ, ഞങ്ങൾ എത്രയും വേഗം മറുപടി നൽകാം.",
    whatsappAgentName: "EtheraGuru സപ്പോർട്ട്",
    whatsappAvailability: "തിങ്കൾ - ശനി, രാവിലെ 12:30 - വൈകുന്നേരം 9:30 IST",
    whatsappDefaultMessage: "ഹായ്! EtheraGuru-നെ കുറിച്ച് കൂടുതൽ അറിയാൻ ഞാൻ ആഗ്രഹിക്കുന്നു.",
    widgetHeader: "ഞങ്ങളോട് ചാറ്റ് ചെയ്യൂ",
    widgetBody: "ഹായ്! ഇന്ന് ഞങ്ങൾ എങ്ങനെ സഹായിക്കാം? വാട്സാപ്പ് സംഭാഷണം ആരംഭിക്കാൻ താഴെ ടാപ്പ് ചെയ്യൂ.",
    widgetTooltip: "വാട്സാപ്പിൽ ചാറ്റ് ചെയ്യൂ",
    startChatCta: "ചാറ്റ് ആരംഭിക്കുക",
    startWhatsappChatCta: "വാട്സാപ്പ് ചാറ്റ് ആരംഭിക്കുക",
    messageLabel: "നിങ്ങളുടെ സന്ദേശം",
    messagePlaceholder: "നിങ്ങളുടെ സന്ദേശം ടൈപ്പ് ചെയ്യൂ...",
  },
};
